import React from 'react';
import { GrInstagram, GrFacebookOption, GrLinkedinOption, GrTwitter, GrYoutube } from 'react-icons/gr';


const SocialIcons = () => {
  return (
    <div className="social_icons">
    <div>
      <a
        href="https://www.instagram.com/portodeaveiro_/?hl=en"
        target="_blank"
        rel="noreferrer"
      >
        <GrInstagram />
      </a>
    </div>
    <div>
      <a
        href="https://www.facebook.com/portoaveiro"
        target="_blank"
        rel="noreferrer"
      >
        <GrFacebookOption />
      </a>
    </div>
    <div>
      <a
        href="https://www.linkedin.com/company/porto-de-aveiro?original_referer=https%3A%2F%2Fportodeaveiro.pt%2F"
        target="_blank"
        rel="noreferrer"
      >
        <GrLinkedinOption />
      </a>
    </div>
    <div>
      <a
        href="https://twitter.com/portodeaveiro"
        target="_blank"
        rel="noreferrer"
      >
        <GrTwitter />
      </a>
    </div>
    <div>
      <a
        href="https://www.youtube.com/channel/UCy21hu9arm-URhZ9wSIzw6w"
        target="_blank"
        rel="noreferrer"
      >
        <GrYoutube />
      </a>
    </div>
  </div>

  )
}

export default SocialIcons;